module.exports = __webpack_public_path__ + "img/buessiness_htwl_c1.deb1e323.png";